module.exports = (words, query) => {
    return words.replace(query, `<span class="highlight">${query}</span>`);
};